module.exports = __webpack_public_path__ + "static/media/The High Sparrow 1.015dd4ad.jpg";